import lottieAnimation from "../../../../assets/svg/lottie_Animation.json";
import Lottie from "lottie-react";
import React from "react";
import {
  BoldSubtitleText,
  LottiHolder,
  PaymentGraphicsContainer,
  SubtitleText,
  SubtitleTextHolder,
  TitleText,
} from "./PaymentGraphics.styles";

const PaymentGraphics = () => {
  return (
    <PaymentGraphicsContainer>
      <LottiHolder>
        <Lottie animationData={lottieAnimation} />
      </LottiHolder>

      <TitleText>Payment Successful</TitleText>
      <SubtitleTextHolder>
        <SubtitleText> You've successfully sent </SubtitleText>
        <BoldSubtitleText>$100</BoldSubtitleText>
        <SubtitleText> to Sarah Jacobs </SubtitleText>
      </SubtitleTextHolder>
    </PaymentGraphicsContainer>
  );
};

export default PaymentGraphics;
